import React from 'react'
import { toast } from "react-toastify";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import { useLocation } from "react-router-dom";

import useUrlQueryParams from "hooks/useUrlQueryParams";
import { TableContent } from "components/__new/common/TableContent";
import DateFormat, { MonthIndex, MonthName, PadMonthIndex, MonthYearFormat } from "utils/dateFormat";
import CurrencyFormat from "utils/currencyFormat";
import logger from "utils/logger";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import processParams from "utils/processParams";
import useLoginInfo from "hooks/useLoginInfo";

import Filter, { ActiveFilter } from "components/__new/common/Filter";
import { ReactComponent as IconCloud } from "assets/images/icons/project-icons/cloud-download.svg";
import * as InvoiceAction from "store/entities/invoice/action";
import { renderStatusColor } from 'utils/statusColor';



const PaymentNotesList = ({setInvoices}) => {
    const location = useLocation();
    const {userInfo} = useLoginInfo();
    const dispatch = useDispatch();
    const {urlQueryParams} = useUrlQueryParams();
    const [downloadInvoicePDFInitiated, setDownloadInvoicePDFInitiated] = useState(false);
    
    // const { InlineRouterTab } = useInlinePageRouter();
    const { InlineRouterTab, activeTab } = useInlinePageRouter("reconcilliation");
    const isPaymentNotes = activeTab === "payment-notes";
    
    // paymentNotesDownload: {},
    // paymentNotes: {},
    // paymentNote: {},
    // invoicePDF: {},
    const { invoicePDFLoading, invoicePDF, paymentNoteLoading, paymentNote,  paymentNotesLoading: reportLoading, paymentNotes: report, paymentNotesDownloadLoading: reportDownloadLoading, paymentNotesDownload: reportDownload } = useSelector((s) => s.entities.invoice);
    
    const downloadAsCSVRef = useRef();
    const printComponentRef = useRef();
    const [month, setMonth] = useState(""); // eslint-disable-line
    const [year, setYear] = useState(""); // eslint-disable-line
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    
    // console.log({
    //     paymentNotesDownload: reportDownload,
    //     paymentNotes: report,
    // paymentNote,
    // invoicePDF,
    // })
    
    
    useEffect(() => {
        setInvoices(report)
    }, [report]);
    

    const setDefaultMonthYear = () => {
        const date = new Date();
        const currentMonthIndex = (date.getMonth() + 1);
        const month = MonthName(currentMonthIndex);
        const year = date.getFullYear();
        setMonth(month);
        setYear(year);
    }
    
    
    const transformFilters = (params) => {
        let paramsPayload = {...params};
        if (params.month && params.year){
            paramsPayload = {
                ...paramsPayload,
                month: PadMonthIndex(MonthIndex(params.month)),
                year: params.year,
            };
        }
        return paramsPayload;
    }
    
    
    const downloadInvoicePDF = (paymentNote) => {
        const downloadInvoicePDFParams = {
            paymentId: paymentNote.invoiceId,
        }
        setMonth(MonthName(paymentNote.month));
        setYear(paymentNote.year);
        setDownloadInvoicePDFInitiated(true);
        dispatch(InvoiceAction.downloadInvoicePDF(downloadInvoicePDFParams));
        toast("Downloading PDF");
    }
    
    
    const getReport = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "search", "string", "", "keyword");
        params = processParams(urlQueryParams, params, "month", "string", "", "month");
        params = processParams(urlQueryParams, params, "year", "string", "", "year");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        
        if (params?.month && params?.year){
            setMonth(params?.month);
            setYear(params?.year);
        }
        else{
            setDefaultMonthYear();
        }
        
        setListParams(params);
        const paramsPayload = transformFilters(params);
        dispatch(InvoiceAction.getAllInvoice(paramsPayload));
    }


    /*
    const removeDuplicates = (data) => {
        if (data){
            let response = {...data, docs: []};
            let dataIds = [];
            
            if (data && data.docs && data.docs.length > 0){
                data.docs.map((output) => {
                    if (dataIds.indexOf(output._id) === -1){
                        response.docs.push(output);
                        dataIds.push(output._id);
                    }
                    return "";
                })
            }
            
            return response;
        }
        return data;
    }
    */


    useEffect(() => {
        setDefaultMonthYear();
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        getReport();
        logger("employer-invoice-report", userInfo);
        // eslint-disable-next-line
    }, [location]);

    const handleFilterChange = (value = "") => {
        setListParams({...listParams, value});
    }
    
    
    useEffect(() => {
        if (downloadInvoicePDFInitiated === true){
            if (invoicePDFLoading === false){
                if (invoicePDF?.status === "success"){
                    const linkSource = `data:application/pdf;base64,${invoicePDF?.pdf}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `Payment Note (${month} ${year}).pdf`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    toast.success("PDF downloaded");
                }
                else{
                    toast.error("An error occurred while downloading payment note.");
                }

                setDownloadInvoicePDFInitiated(false);
            }
        }
        // eslint-disable-next-line
    }, [invoicePDFLoading, invoicePDF]);

    
    
  return (
    <div className="">
                    <div className="px-4 font-medium text-xl">
                        Payment Notes
                    </div>
                    
                    <div className="px-4 mt-6 flex flex-wrap justify-between">
                        <div className="max-w-sm flex-grow sm:mr-6">
                            <SearchBox placeholder="Search Payment ID" name="search" extraUrlParams="page=1" />
                        </div>
                        <div className="flex flex-wrap space-x-3 sm:space-x-6">
                            <div>
                            <Filter filters={[
                                {
                                    title: "Status",
                                    name: "status",
                                    dataType: "select",
                                    options: [
                                        {
                                            display: "All",
                                            payload: "",
                                        },
                                        {
                                            display: "Paid",
                                            payload: "paid",
                                        },
                                        {
                                            display: "Unpaid",
                                            payload: "unpaid",
                                        },
                                    ],
                                },
                            ]}/>
                                {/* <Filter filters={[
                                    {
                                        title: "Month & Year",
                                        dataType: "month-year",
                                        option: {
                                            name: "month-year",
                                            placeholder: "Select",
                                        },
                                    },
                                ]}/> */}
                            </div>
                            {/* <div>
                                <DownloadAsCSV
                                    ref={downloadAsCSVRef}
                                    tooltip="Download monthly reconciliation"
                                    filename="Monthly Reconciliation.csv"
                                    columns={[
                                        { label: "First Name", key: "firstName" },
                                        { label: "Last Name", key: "lastName" },
                                        { label: "Email Address", key: "email" },
                                        { label: "Bank Name", key: "bankName" },
                                        { label: "Bank Account Number", key: "bankAccountNumber" },
                                        { label: "Net Monthly Salary", key: "netMonthlySalary" },
                                        { label: "Amount Withdrawn", key: "totalAmountWithdrawn" },
                                        { label: "Last Withdrawn Date", key: "lastWithdrawn" },
                                        { label: "Salary Balance", key: "salaryBalance" },
                                    ]}
                                    click={() => {
                                        dispatch(payrollAction.downloadGetAllPayroll(transformFilters({...listParams, page: 1, limit: 10000}))).then(() => {
                                            downloadAsCSVRef.current?.downloadData();
                                        });
                                    }}
                                    loading={reportDownloadLoading}
                                    response={reportDownload?.docs}
                                />
                            </div> */}

                            {/* <div>
                                <Print component={printComponentRef} />
                            </div> */}
                        </div>
                    </div>

                    <div className="px-4">
                        <ActiveFilter filters={{"Month & Year": "month-year"}} />
                    </div>
                    
                    <div className="mt-6">
                        <div ref={printComponentRef}>
                            
                            <div className="mb-4 text-xl hidden print:block">
                                Payment Notes
                            </div>

                            <Table>
                                <Table.Head>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Payment ID</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Period</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Due Date</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Amount to be paid</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'>Status</th>
                                    <th style={{fontWeight: 500}} className='text-ep-gray-600 font-medium'></th>
                                </Table.Head>
                                <Table.Body>

                                    <TableContent
                                        loading={reportLoading}
                                        loadingText="Loading payment notes"
                                        data={report?.invoices}
                                        colspan={6}
                                    />

                                    {reportLoading === false && report?.invoices?.docs?.map((reportData) =>
                                        <tr key={reportData?._id}>
                                            <td>
                                                <div className="capitalize font-medium text-ep-gray-300">
                                                    {reportData?.invoiceId}
                                                </div>
                                            </td>
                                            <td>
                                            {MonthYearFormat(reportData?.dueDate)}
                                            </td>
                                            <td>
                                            {DateFormat(reportData?.dueDate)}
                                            </td>
                                            <td>
                                                {CurrencyFormat(reportData?.amountPaid) ?? "-"}
                                            </td>
                                            <td>
                                            <div className='font-medium'>
                                                <div className={"label capitalize " + renderStatusColor(reportData?.status)}>
                                                    {reportData?.status}
                                                </div>
                                            </div>
                                            </td>
                                            <td>
                                                <button onClick={() => downloadInvoicePDF(reportData)}>
                                                    <IconCloud />
                                                </button>
                                            </td>
                                        </tr>
                                    )}

                                </Table.Body>
                            </Table>

                            <Maybe condition={reportLoading === false && report?.invoices?.docs?.length > 0}>
                                <div className="mt-6">
                                    <Pagination data={report?.invoices} />
                                </div>
                            </Maybe>

                        </div>
                    </div>
                </div>
  )
}

export default PaymentNotesList